<template>
    <eqt-table @refresh="refresh" @delete="deleteItem" :total="total" :loading="loading" :title="$t('Pages.Vehicles.title')" :subtitle="$t('Common.table_subtitle')" :items="items" :headers="headers">
        <template slot="items" slot-scope="{ item }">
            <td>{{ item.id }}</td>
            <td>{{ item.licence_plates}}</td>
            <td>{{ item.name}}</td>
            <td>{{ item.model}}</td>
            <td>{{ item.year}}</td>
        </template>
    </eqt-table>
</template>

<script>
    import i18n from '@/i18n'
    import EqtTable from '../../components/core/Table'
    export default {
        name: "vehicles-table",
        components: {EqtTable},
        props: {
            items: {
              type: Array,
              required: true
            },
            total: {
                type: Number,
                default: 0,
            },
            loading: {
                type: Boolean,
                required: true
            },
            hideActions: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            headers: [
                {
                    sortable: true,
                    text: '#',
                    value: 'id'
                },
                {
                    sortable: true,
                    text: i18n.t('Pages.Vehicles.model.licence_plates'),
                    value: 'licence_plates'
                },
                {
                    sortable: true,
                    text: i18n.t('Pages.Vehicles.model.name'),
                    value: 'name'
                },
                {
                    sortable: true,
                    text: i18n.t('Pages.Vehicles.model.model'),
                    value: 'model'
                },
                {
                    sortable: true,
                    text: i18n.t('Pages.Vehicles.model.year'),
                    value: 'year'
                },
            ],
        }),
        computed:{

        },
        methods: {
            refresh(data){
                this.$emit('refresh', data);
            },
            deleteItem(item){
                this.$emit('delete', item);
            }
        },
        watch: {

        }
    }
</script>

<style scoped>

</style>
